import Vue from 'vue'
import VueRouter from 'vue-router'
import authorizesNavigation from './middlewares/AuthorizesNavigation'
import Init from '../services/commons/Init.js'
import captoolRoutes from './captoolRoutes'

Vue.use(VueRouter)
let routes
const project = Init.initConfiguration()

if (project.x_dds_label === 'ddcaptool') {
  routes = captoolRoutes
} else {
  routes = captoolRoutes
}

const router = new VueRouter({
  routes
})

export const bootstrap = async () => {
  authorizesNavigation(router)
}

export default router
